// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-page-js" + "-" + "117de186b76e4b4551df" + ".js";
};